@if (config(); as modalConfig) {
  <p-dialog
    [closable]="false"
    [closeOnEscape]="false"
    [dismissableMask]="false"
    [draggable]="false"
    [focusOnShow]="modalConfig.focusOnShow ?? false"
    [header]="modalConfig.title || 'Warning'"
    [modal]="true"
    [resizable]="false"
    [styleClass]="modalConfig.styleClass ?? ''"
    [visible]="isVisible()"
    (onHide)="onClose()"
  >
    <!-- Our own X instead of PrimeNG's, which closes the dialog before an onClose hook could keep it open. -->
    <ng-template #header>
      <div class="flex w-full items-center justify-between">
        <span class="p-dialog-title">{{ modalConfig.title || 'Warning' }}</span>
        @if (modalConfig.closable) {
          <button aria-label="Close"
                  class="p-dialog-close-button"
                  data-test="albert-modal-close"
                  iconOnly
                  pButton
                  severity="secondary"
                  type="button"
                  [rounded]="true"
                  [text]="true"
                  (click)="requestClose()"
          >
            <i class="pi pi-times"></i>
          </button>
        }
      </div>
    </ng-template>

    @if (modalConfig.contentTemplate; as contentTemplate) {
      <ng-container *ngTemplateOutlet="contentTemplate"/>
    } @else {
      <div class="flex flex-col items-start gap-4 py-4">
        <p class="mt-1 text-lg error-subsystem-name">{{ modalConfig.subsystemName }}</p>
        <p class="mt-1 text-lg">{{ modalConfig.message }}</p>
      </div>
    }

    <ng-template #footer>
      <div class="flex w-full justify-between items-center">
        <div class="flex gap-2">
          @for (action of leftActions(); track action.label) {
            <button pButton
                    severity="secondary"
                    type="button"
                    [class]="action.styleClass"
                    [text]="true"
                    (click)="handleAction(action)"
            >
              {{ action.label }}
            </button>
          }
        </div>
        <div class="flex gap-2">
          @for (action of rightActions(); track action.label) {
            <button pButton
                    type="button"
                    [class]="action.styleClass"
                    [outlined]="action.outlined ?? false"
                    [severity]="action.severity ?? getButtonSeverity(modalConfig.type)"
                    (click)="handleAction(action)"
            >
              {{ action.label }}
            </button>
          }
        </div>
      </div>
    </ng-template>
  </p-dialog>
}
